import React from "react"

import { Grid } from "@mui/material"
import { Typography } from "@synapse-analytics/synapse-ui"

/**
 * Recharts graph custom labels components
 * GraphLabelText -> label
 *                   text   smallText
 *
 * GraphLabelText (bottomLabel variant) -> text smallText
 *                                         label
 * GraphLabelText (noLabel variant) -> text
 *                                         smallText
 * @return {React.ReactElement}
 */

interface GraphLabelProps {
  label: {
    name?: string
    value: number
    percent?: number
  }
  bottomLabel?: boolean
  noLabel?: boolean
}

export function GraphLabelText(props: Readonly<GraphLabelProps>): React.ReactElement {
  const { label, bottomLabel, noLabel } = props

  return (
    <Grid container direction={bottomLabel ? "column-reverse" : "column"}>
      {!!label.name && (
        <Grid container item xs={12}>
          <Typography variant="label-regular" noWrap>
            {label.name}
          </Typography>
        </Grid>
      )}
      <Grid container item xs={12} wrap={noLabel ? "wrap" : "nowrap"} display={"row"}>
        <Grid item mr={0.5} xs={noLabel ? 12 : "auto"}>
          <Typography variant="h2-bold">{label.value}</Typography>
        </Grid>
        {!!label.percent && (
          <Grid item alignSelf={"center"} xs={noLabel ? 12 : "auto"}>
            <Typography variant="label-regular">{label.percent}%</Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}
